exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-divider[data-v-c2694ed0]{border-top:3px solid rgb(228 228 228)!important;width:50%!important;margin-top:28px;margin-bottom:28px}", ""]);

// exports
